var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMv = function SvgMv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007e3a",
    d: "M120 120h400v240H120z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 80,
    cy: 240,
    cx: 350,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 80,
    cy: 240,
    cx: 380,
    fill: "#007e3a"
  })));
};
export default __webpack_public_path__ + "assets/54ceb5e0ccb5540c3d63f3651ab21b2d.svg";
export { SvgMv as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/mv.svg